import { responsiveWrapper } from 'react-responsive-redux'

import sizes from './sizes'

export const DesktopScreen = responsiveWrapper({ minWidth: sizes.screen + 1 })

export const MobileScreen = responsiveWrapper({ maxWidth: sizes.screen })
